"use strict";
/* globals module */
/**
 * @module filesACLRoute
 * @description Baasic Files ACL Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Files Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var common_1 = require("../../common");
;
var contracts_1 = require("../../core/contracts");
var FilesACLRoute = /** @class */ (function (_super) {
    tslib_1.__extends(FilesACLRoute, _super);
    function FilesACLRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.getRoute = 'files/{id}/acl/{?fields}';
        _this.updateRoute = 'files/{id}/acl/{?fields}';
        _this.deleteByUserRoute = 'files/{id}/acl/actions/{accessAction}/users/{user}/';
        _this.deleteByRoleRoute = 'files/{id}/acl/actions/{accessAction}/roles/{role}/';
        return _this;
    }
    /**
     * Parses get acl route; this URI template should be expanded with the Id of the file resource.
     * @method
     * @example filesACLRoute.get({id: '<file-id>'});
     **/
    FilesACLRoute.prototype.get = function (options) {
        var params = this.utility.extend({}, options);
        return _super.prototype.baseCreate.call(this, this.getRoute, params);
    };
    /**
     * Parses update acl route; this URI template should be expanded with the Id of the file resource.
     * @method
     * @example filesACLRoute.update({id: '<file-id>'});
     **/
    FilesACLRoute.prototype.update = function (options) {
        var params = this.utility.extend({}, options);
        return _super.prototype.baseCreate.call(this, this.updateRoute, params);
    };
    /**
     * Parses deleteByUser acl route which can be expanded with additional options. Supported items are:
     * - `id` - File id which uniquely identifies file resource whose security privileges need to be retrieved and updated.
     * - `accessAction` - Action abbreviation which identifies ACL policy assigned to the specified user and file resource.
     * - `user` - A value which uniquely identifies user for which ACL policy needs to be removed.
     * @method
     * @param id File id which uniquely identifies file resource whose security privileges need to be retrieved and updated.
     * @param action Action abbreviation which identifies ACL policy assigned to the specified user and file resource.
     *               Supported Values:
     *               "Create"
     *               "Delete"
     *               "Read"
     *               "Update"
     * @param user A value that uniquely identifies user for which ACL policy needs to be removed.
     * @example filesACLRoute.deleteByUser({ id: '<file-id>', accessAction: '<access-action>', user: '<username>' });
     **/
    FilesACLRoute.prototype.deleteByUser = function (id, action, user, data) {
        var params = this.modelMapper.removeParams(data);
        params.id = id;
        params.user = user;
        params.accessAction = action;
        return _super.prototype.baseCreate.call(this, this.deleteByUserRoute, params);
    };
    /**
     * Parses deleteByUser acl route which can be expanded with additional options. Supported items are:
     * - `id` - File id which uniquely identifies file resource whose security privileges need to be retrieved and updated.
     * - `accessAction` - Action abbreviation which identifies ACL policy assigned to the specified role and file resource.
     * - `role` - A value which uniquely identifies role for which ACL policy needs to be removed.
     * @method
     * @param id File id which uniquely identifies file resource whose security privileges need to be retrieved and updated.
     * @param action Action abbreviation which identifies ACL policy assigned to the specified user and file resource.
     *               Supported Values:
     *               "Create"
     *               "Delete"
     *               "Read"
     *               "Update"
     * @param role A value that uniquely identifies role for which ACL policy needs to be removed.
     * @example filesACLRoute.deleteByRole({ id: '<file-id>', accessAction: '<access-action>', role: '<role-name>' });
     **/
    FilesACLRoute.prototype.deleteByRole = function (id, action, role, data) {
        var params = this.modelMapper.removeParams(data);
        params.id = id;
        params.role = role;
        params.accessAction = action;
        return _super.prototype.baseCreate.call(this, this.deleteByRoleRoute, params);
    };
    FilesACLRoute.prototype.updateParams = function (data) {
        var params = this.utility.extend({}, data);
        return params[this.modelMapper.modelPropertyName];
    };
    var _a;
    FilesACLRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], FilesACLRoute);
    return FilesACLRoute;
}(common_1.BaseRoute));
exports.FilesACLRoute = FilesACLRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 
